<template>
  <div
    class="relative w-full"
    :class="{
      'pt-3': isFree,
    }"
  >
    <FreeLabel v-if="isFree" class="absolute left-4 top-0 w-max" />
    <div
      class="bg-background-neutral-secondary w-full space-y-4 overflow-x-hidden rounded-2xl p-4"
      :class="{
        'border-background-negative-primary rounded-2xl border': hasError,
        'pt-6': isFree,
      }"
    >
      <div class="flex items-center space-x-2">
        <picture>
          <source
            type="image/webp"
            srcset="@/assets/images/medical-insurance-icon.webp"
          />
          <img
            src="@/assets/images/medical-insurance-icon.png"
            width="56"
            height="56"
            alt=""
          />
        </picture>
        <div class="w-full space-y-0.5 text-left">
          <h2
            class="text-text-neutral-primary flex items-center justify-between whitespace-nowrap text-base font-semibold"
          >
            <span>
              {{ medicalInsuranceProducts[0].title }}
            </span>
            <button
              type="button"
              class="shrink-0 rounded-full active:shadow-md"
              @click="
                bottomSheet.show(medicalInsuranceConfig.DETAILS_BOTTOM_SHEET)
              "
            >
              <InfoIcon />
            </button>
          </h2>

          <p class="text-text-neutral-secondary text-sm">
            {{ medicalInsuranceProducts[0].short_description }}
          </p>
        </div>
      </div>

      <FreeButton
        size="sm"
        type="button"
        class="w-full"
        :class="
          bookingStore.medicalInsuranceProducts.length > 0
            ? 'gray-button'
            : 'green-main-button'
        "
        @click="emit('onOpenMedicalInsuranceBottomSheet')"
      >
        {{
          bookingStore.medicalInsuranceProducts.length > 0
            ? t('general.edit')
            : t('general.add')
        }}
      </FreeButton>
    </div>
    <MedicalInsuranceDetailsBottomSheet
      :name="medicalInsuranceConfig.DETAILS_BOTTOM_SHEET"
    />
    <MedicalInsuranceConditionsBottomSheet
      :name="medicalInsuranceConfig.CONDITIONS_BOTTOM_SHEET"
    />
  </div>
</template>
<script setup lang="ts">
  import { computed } from 'vue';
  import { FreeButton, FreeLabel } from 'freedom-shared';
  import { useI18n } from 'vue-i18n';
  import type { Airflow } from '@aviata/platform-types';
  import { controllerModel } from 'shared';

  import { bookingStateModel } from '@/features/booking-state';

  import InfoIcon from '@/assets/images/product-details-icon.svg?component';

  import { medicalInsuranceConfig } from '../config';
  import MedicalInsuranceDetailsBottomSheet from './MedicalInsuranceDetailsBottomSheet.vue';
  import MedicalInsuranceConditionsBottomSheet from './MedicalInsuranceConditionsBottomSheet.vue';

  const { t } = useI18n();

  const props = defineProps<{
    medicalInsuranceProducts: Airflow.Products.Product[];
    hasError: boolean;
  }>();

  const emit = defineEmits<{
    onOpenMedicalInsuranceBottomSheet: [];
  }>();

  const bookingStore = bookingStateModel.useBookingStore();

  const isFree = computed(() =>
    props.medicalInsuranceProducts.some(p => p.$meta?.special?.promotion),
  );

  const bottomSheet = controllerModel.useBottomSheet();
</script>
